import { ItemWithPrefixedRecordId, OpraReportTemplate } from '@interfaces/report-templates.interface';
import { AuditServiceType } from 'types/graphql-global-types';
import { auditRecordIdPrefixes } from '@queries/generated/audit.generated';

export const getPrefixByService = (
    prefixes: auditRecordIdPrefixes['auditRecordIdPrefixes'],
    serviceType: AuditServiceType,
) => {
    return prefixes?.find((item) => item?.service === serviceType)?.prefix || '';
};

export const addPrefixedRecordIdsToTemplates = <T extends { recordId?: number }>(
    templates: T[],
    serviceType: AuditServiceType,
    prefixes?: auditRecordIdPrefixes['auditRecordIdPrefixes'],
): (T & ItemWithPrefixedRecordId)[] => {
    const prefix = prefixes?.find((p) => p?.service === serviceType)?.prefix;
    return templates.map((t) => ({
        ...t,
        _itemId: `${prefix}${t.recordId}`,
    }));
};

export const addPrefixedRecordIdsAndTemplateNamesToReportTemplates = (
    templates?: OpraReportTemplate[],
    prefixes?: auditRecordIdPrefixes['auditRecordIdPrefixes'],
) => {
    if (!templates) return [];
    const prefix = prefixes?.find((p) => p?.service === AuditServiceType.REPORTING)?.prefix;
    return templates.map((t) => ({
        ...t,
        fullName: t.includeInternalRisks ? `INTERNAL ${t.templateName}` : t.templateName,
        _itemId: `${prefix}${t.recordId}`,
    }));
};

export const addPrefixedOrganisationTemplateId = <T extends { organizationReportTemplateRecordId?: number | null }>(
    templates: T[],
    serviceType: AuditServiceType,
    prefixes?: auditRecordIdPrefixes['auditRecordIdPrefixes'],
) => {
    const prefix = prefixes?.find((p) => p?.service === serviceType)?.prefix;
    return templates.map((t) => ({
        ...t,
        _orgDbId: `${prefix}${t.organizationReportTemplateRecordId}`,
    }));
};
